<script lang="ts" setup>
import { onBeforeMount, ref } from "vue";
import { useRouter } from "vue-router";
import { accountService } from "@/app/services/AccountService";
import { authService } from "@/app/services/AuthService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import PasswordInputGroup from "@/components/molecules/form/PasswordInputGroup.vue";
import Header from "@/components/organisms/common/Header.vue";
import { useLoader } from "@/utils/loader";
import { useErrorModal, useModal } from "@/utils/modal";

const errorModal = useErrorModal();
const modal = useModal();
const loader = useLoader();
const router = useRouter();

const oldPassword = ref("");
const newPassword = ref("");

onBeforeMount(async () => {
  await accountService.updateUserData();
});

function onClickBack() {
  router.back();
}

async function onClickButton() {
  loader.show();
  try {
    const body = {
      oldPassword: oldPassword.value,
      newPassword1: newPassword.value,
      newPassword2: newPassword.value
    };
    await authService.changePassword(body);
    await showSuccessModal();
    onClickBack();
  } catch (error) {
    await errorModal.showErrorModal(error as Error);
  } finally {
    loader.hide();
  }
}

async function showSuccessModal() {
  await modal.msgBoxOk("新しいパスワードが登録されました。", {
    okVariant: "success",
    centered: true
  });
}
</script>

<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      パスワードリセット
    </Header>

    <div class="reset-password px-3 py-4">
      <CustomValidationObserver
        ref="form"
        v-slot="{ handleSubmit }"
        tag="div"
        class="w-100"
      >
        <BForm>
          <PasswordInputGroup
            v-model="oldPassword"
            label="現在のパスワード"
            placeholder="入力してください"
            hideHelpText
            vid="oldPassword"
            data-testid="oldPassword"
          />

          <PasswordInputGroup
            v-model="newPassword"
            label="新しいパスワード"
            placeholder="入力してください"
            class="mt-3"
            vid="newPassword"
            data-testid="newPassword"
          />

          <div class="pt-3 mt-4">
            <AppButton
              block
              @click="handleSubmit(onClickButton)"
              data-testid="submitButton"
            >
              設定する
            </AppButton>
          </div>
          <div class="pt-3 text-center">
            <RouterLink
              class="text-size-14 text-mild text-decoration-underline"
              :to="{ name: 'ResetPasswordAfterLogin' }"
              data-testid="forgot"
            >
              パスワードを忘れた場合
            </RouterLink>
          </div>
        </BForm>
      </CustomValidationObserver>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.note {
  font-size: 0.75rem;
  color: $gray-05;
}

.text-decoration-underline {
  text-decoration: underline;
}
</style>
